import React from "react";
import {
  ArrayInput,
  Button,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleFormIterator,
  useNotify,
  useSimpleFormIteratorItem,
} from "react-admin";
import { useWatch } from "react-hook-form";
import FormModal from "server/components/Modals/FormModal";
import EditIcon from "@mui/icons-material/Edit";
import { settings } from "app";
import { Grid } from "@mui/material";
import { graduationRequests } from "api/graduationApi";
import dataProvider from "server/dataProvider";

const RequirementReferenceInput = ({ planId }) => {
  const { index } = useSimpleFormIteratorItem();
  const requirements = useWatch({ name: "requirements" }) || [];

  const excludeIds = requirements.map((r, i) => (i !== index ? r?.requirementId : null)).filter(Boolean);

  return (
    <ReferenceInput
      source="requirementId"
      reference={graduationRequests.getPlanDisciplinesRequirements(planId)}
      filter={excludeIds.length > 0 ? { ExcludeIds: excludeIds } : {}}
    >
      <SelectInput
        label="Норматив"
        emptyText={false}
        optionText={rec => (
          <div style={{ display: "flex", flexDirection: "column", fontSize: 14 }}>
            <span>
              Име норматив: <strong>{rec.requirementNameBg}</strong>
            </span>
            <span>
              Дисциплина: <strong>{rec.disciplineNameBg}</strong>
            </span>
            <span>
              Норматив: <strong>{rec.requiredCount}</strong>
            </span>
          </div>
        )}
      />
    </ReferenceInput>
  );
};

const RequirementsDialog = ({ planId, studentEducationId, fetchRequirements, requirements }) => {
  const notify = useNotify();

  const handleSubmit = async data => {
    // Send only new or changed rows, otherwise the backend writes a history entry for every requirement
    const changed = (data.requirements ?? []).filter(r => {
      if (!r?.requirementId) return false;
      const initial = requirements?.find(i => i.requirementId === r.requirementId);
      return !initial || initial.achievedCount !== r.achievedCount;
    });

    if (changed.length === 0) {
      notify("Няма променени нормативи", { type: "warning" });
      return false;
    }

    const payload = {
      requirements: changed.map(r => ({
        requirementId: r.requirementId,
        achievedCount: r.achievedCount,
      })),
    };

    await dataProvider.customRequest(
      graduationRequests.studentDisciplinesRequirements(studentEducationId),
      payload,
      "PATCH",
    );
    notify("Успешно отбелязване на изпълнени нормативи");
    fetchRequirements();
  };

  return (
    <FormModal
      titleContent={"Отбелязване на изпълнени нормативи"}
      onConfirm={handleSubmit}
      dialogSize="xl"
      triggerButton={
        <Button
          label="Отбележи изпълнение"
          variant="contained"
          startIcon={<EditIcon />}
          sx={{ ml: 2 }}
        />
      }
    >
      <ArrayInput
        source="requirements"
        label=" "
        defaultValue={requirements && requirements.length > 0 ? requirements : [{}]}
      >
        <SimpleFormIterator
          disableReordering
          inline
          sx={settings.style.iteratorWithoutGap}
        >
          <Grid
            container
            spacing={2}
          >
            <RequirementReferenceInput planId={planId} />

            <NumberInput
              label="Изпълнено"
              source="achievedCount"
            />
          </Grid>
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default RequirementsDialog;
